export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/en.lyaml"));
vm(require("feature-monetization/lang/en.lyaml"));
at({ "en": { "publicPricingPage": { "windowTitles": { "default": "Pricing | HubSpot" } } } });
};